<form class="form" id="performa_add_form" [formGroup]="proformaForm" (ngSubmit)="onSubmit()" #performa_add_form>
	<div class="card card-flush">
		<div class="card-header pt-8">
			<div class="card-title">
				<img alt="Logo" src="/assets/media/logos/default.svg" />
			</div>
			<div class="card-toolbar flex-row-fluid justify-content-end gap-3">
				<div class="fv-row row">
					<div class="col-md-6 col-sm-12 mb-5">
						<div class="form-floating">
							<input type="text" id="proformaNumber" formControlName="proformaNumber"
								class="form-control min-h-40px h-40px fs-7 bg-light"
								placeholder="Auto Generated"
								value="Auto Generated"
								readonly />
							<label for="proformaNumber" class="fs-7 text-gray-600">Proforma Number :</label>
						</div>
					</div>
					<div class="col-md-6 col-sm-12 mb-5">
						<div class="form-floating">
							<input type="text" id="proformaDate" formControlName="proformaDate"
								class="form-control min-h-40px h-40px fs-7 bg-light"
								placeholder="Auto Generated"
								value="Auto Generated"
								readonly />
							<label for="proformaDate" class="fs-7 text-gray-600">Proforma Date</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-body">
			<div class="fv-row row mb-15">
				<div class="col-md-6 col-sm-12 d-flex flex-column">
					<div class="d-flex justify-content-between align-center mb-5">
						<h4 class="mb-0 d-flex align-items-center">Buyer Information <span class="required"></span></h4>
						<!-- <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#performa_add_company"><i class="ki-duotone ki-plus fs-2"></i> Add Company</button> -->
					</div>
					<div class="form-floating mb-5 position-relative">
						<input
							type="text"
							id="buyerCompanyName"
							class="form-control h-50px fs-7 bg-light"
							[class.is-invalid]="isFieldInvalid('buyerCompanyName')"
							placeholder="Company Name"
							[(ngModel)]="companySearchTerm"
							[ngModelOptions]="{standalone: true}"
							autocomplete="off"
							readonly />
						<label for="buyerCompanyName" class="fs-7 text-gray-600"><span class="required">Company Name</span></label>

						<!-- Validation Error Message -->
						<div *ngIf="isFieldInvalid('buyerCompanyName')" class="text-danger fs-7 mt-1">
							{{ getFieldError('buyerCompanyName') }}
						</div>
					</div>
					<div class="row mb-5">
						<div class="col-md-4">
							<div class="form-floating">
								<select class="form-select h-50px fs-7 bg-light" formControlName="buyerTitle"
									[class.is-invalid]="isFieldInvalid('buyerTitle')"
									>
									<option value="Mr.">Mr.</option>
									<option value="Mrs.">Mrs.</option>
									<option value="Miss">Miss</option>
								</select>
								<label for="initialSelect"><span class="required">Initial</span></label>
								<div *ngIf="isFieldInvalid('buyerTitle')" class="invalid-feedback">
									{{ getFieldError('buyerTitle') }}
								</div>
							</div>
						</div>
						<div class="col-md-8">
							<div class="form-floating">
								<input type="text" formControlName="buyerName" id="consigneeName"
									class="form-control h-50px fs-7 bg-light"
									[class.is-invalid]="isFieldInvalid('buyerName')"
									placeholder="Consignee Name"
									readonly />
								<label for="consigneeName" class="fs-7 text-gray-600"><span class="required">Consignee Name</span></label>
								<div *ngIf="isFieldInvalid('buyerName')" class="invalid-feedback">
									{{ getFieldError('buyerName') }}
								</div>
							</div>
						</div>
					</div>
					<div class="fv-row row">
						<div class="col-md-4 col-sm-12  mb-5">
							<div class="form-floating">
								<input type="text" formControlName="buyerAddress" id="buyerstreetAddress"
									class="form-control h-50px fs-7 bg-light"
									[class.is-invalid]="isFieldInvalid('buyerAddress')"
									placeholder="Street Address"
									readonly />
								<label for="buyerStreetAddress" class="fs-7 text-gray-600"><span class="required">Street Address</span></label>
								<div *ngIf="isFieldInvalid('buyerAddress')" class="invalid-feedback">
									{{ getFieldError('buyerAddress') }}
								</div>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="buyerCity" id="buyerCity"
									class="form-control h-50px fs-7 bg-light"
									[class.is-invalid]="isFieldInvalid('buyerCity')"
									placeholder="City"
									readonly />
								<label for="buyerCity" class="fs-7 text-gray-600"><span class="required">City</span></label>
								<div *ngIf="isFieldInvalid('buyerCity')" class="invalid-feedback">
									{{ getFieldError('buyerCity') }}
								</div>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<select class="form-select h-50px fs-7 bg-light" formControlName="buyerCountry" id="buyerCountry"
									[class.is-invalid]="isFieldInvalid('buyerCountry')"
									[attr.disabled]="true">
									<option value="" selected>Select Country</option>
									<option *ngFor="let country of countryList" [attr.data-kt-select2-country]="country.flag" [value]="country.name">{{ country.name }}</option>
								</select>
								<label for="buyerCountry" class="fs-7 text-gray-600"><span class="required">Country</span></label>
								<div *ngIf="isFieldInvalid('buyerCountry')" class="invalid-feedback">
									{{ getFieldError('buyerCountry') }}
								</div>
							</div>
						</div>
					</div>
					<div class="form-floating mb-5">
						<input type="email" formControlName="buyerEmail" id="email"
							class="form-control h-50px fs-7 bg-light"
							[class.is-invalid]="isFieldInvalid('buyerEmail')"
							maxlength="100" placeholder="E-mail Address"
							readonly />
						<label for="email" class="fs-7 text-gray-600"><span class="required">E-mail Address</span></label>
						<div *ngIf="isFieldInvalid('buyerEmail')" class="invalid-feedback">
							{{ getFieldError('buyerEmail') }}
						</div>
					</div>
					<div class="row mb-5">
						<div class="col-md-6">
							<div class="form-floating mb-5">
								<input type="tel" formControlName="buyerPhone1" id="consignee_tel_1"
									class="form-control h-50px fs-7 bg-light"
									[class.is-invalid]="isFieldInvalid('buyerPhone1')"
									maxlength="20" placeholder="Telephone No."
									readonly>
								<label for="consignee_tel_1" class="fs-7 text-gray-600"><span class="required">Telephone No.</span></label>
								<div *ngIf="isFieldInvalid('buyerPhone1')" class="invalid-feedback">
									{{ getFieldError('buyerPhone1') }}
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-floating mb-5">
								<input type="tel" formControlName="buyerPhone2" id="consignee_tel_2" class="form-control h-50px fs-7 bg-light" maxlength="20" placeholder="Telephone No." readonly>
								<label for="consignee_tel_2" class="fs-7 text-gray-600">Telephone No.</label>
							</div>
						</div>
					</div>
					<div class="mb-5">
						<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
							<input class="form-check-input bg-gray-200 rounded-0" formControlName="sameAsConsignee" type="checkbox">
							<span class="fw-semibold ps-2 fs-7">Same As Consignee</span>
						</label>
					</div>
				</div>
				<div class="col-md-6 col-sm-12">
					<div class="d-flex justify-content-between align-center mb-5">
						<h4 class="mb-0 d-flex align-items-center">Shipper Information <span class="required"></span></h4>
						<div class="d-flex gap-2">
							<!-- <button type="button" data-bs-toggle="modal" data-bs-target="#performa_add_to_from_port_for" class="btn btn-sm btn-primary">
								<i class="ki-duotone ki-plus fs-2"></i> Add Port
							</button> -->
						</div>
					</div>
					<div class="form-floating mb-5">
						<input type="text" id="shipperCompanyName" formControlName="shipperCompanyName"
							class="form-control h-50px fs-7 bg-light"
							placeholder="Company Name"
							readonly />
						<label for="shipperCompanyName" class="fs-7 text-gray-600">Company Name</label>
					</div>
					<div class="fv-row row">
						<div class="col-md-6 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperAddress1" id="shipperStreetAddress1"
									class="form-control h-50px fs-7 bg-light"
									placeholder="Address 1"
									readonly />
								<label for="shipperStreetAddress1" class="fs-7 text-gray-600">Address 1</label>
							</div>
						</div>
						<div class="col-md-6 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperAddress2" id="shipperStreetAddress2"
									class="form-control h-50px fs-7 bg-light"
									placeholder="Address 2"
									readonly />
								<label for="shipperStreetAddress2" class="fs-7 text-gray-600">Address 2</label>
							</div>
						</div>
					</div>
					<div class="fv-row row">
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperCity" id="shipperCity"
									class="form-control h-50px fs-7 bg-light"
									placeholder="City"
									readonly />
								<label for="shipperCity" class="fs-7 text-gray-600">City</label>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperState" id="shipperState"
									class="form-control h-50px fs-7 bg-light"
									placeholder="State"
									readonly />
								<label for="shipperState" class="fs-7 text-gray-600">State</label>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperCountry" id="shipperCountry"
									class="form-control h-50px fs-7 bg-light"
									placeholder="Country"
									readonly />
								<label for="shipperCountry" class="fs-7 text-gray-600">Country</label>
							</div>
						</div>
					</div>
					<div class="fv-row row">
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="text" formControlName="shipperZipCode" id="shipperZipCode"
									class="form-control h-50px fs-7 bg-light"
									placeholder="Zip Code"
									readonly />
								<label for="shipperZipCode" class="fs-7 text-gray-600">Zip Code</label>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="tel" formControlName="shipperFax" id="shipperFax"
									class="form-control h-50px fs-7 bg-light"
									maxlength="20"
									placeholder="Fax"
									readonly>
								<label for="shipperFax" class="fs-7 text-gray-600">Fax</label>
							</div>
						</div>
						<div class="col-md-4 col-sm-12 mb-5">
							<div class="form-floating">
								<input type="tel" formControlName="shipperPhone" id="shipperPhone"
									class="form-control h-50px fs-7 bg-light"
									maxlength="20"
									placeholder="Telephone No."
									readonly>
								<label for="shipperPhone" class="fs-7 text-gray-600">Telephone No.</label>
							</div>
						</div>
					</div>
					<div class="fv-row row">
						<div class="col-md-6 col-sm-12">
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select class="form-select h-50px fs-7" formControlName="fromCountry" id="from_country"
											[class.is-invalid]="isFieldInvalid('fromCountry')">
											<option>Select</option>
											<option value="Japan">Japan</option>
										</select>
										<label for="from_country" class="fs-7 text-gray-600"><span class="required">From Country</span></label>
										<div *ngIf="isFieldInvalid('fromCountry')" class="invalid-feedback">
											{{ getFieldError('fromCountry') }}
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select class="form-select h-50px fs-7" formControlName="fromPort" id="from_port"
											[class.is-invalid]="isFieldInvalid('fromPort')">
											<option>Select</option>
											<option value="Any Port In Japan" selected>ANY PORT IN JAPAN</option>
											<option *ngFor="let port of portList" [value]="port.value">{{ port.label }}</option>
										</select>
										<label for="from_port" class="fs-7 text-gray-600"><span class="required">From Port</span></label>
										<div *ngIf="isFieldInvalid('fromPort')" class="invalid-feedback">
											{{ getFieldError('fromPort') }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-sm-12">
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select class="form-select h-50px fs-7" formControlName="toCountry" id="to_country"
											[class.is-invalid]="isFieldInvalid('toCountry')"
											(change)="onToCountryChange('',$any($event.target).value)">
											<option value="" selected>Select</option>
											<option *ngFor="let country of countryList" [attr.data-kt-select2-country]="country.flag" [value]="country.name">{{ country.name }}</option>
										</select>
										<label for="to_country" class="fs-7 text-gray-600"><span class="required">To Country</span></label>
										<div *ngIf="isFieldInvalid('toCountry')" class="invalid-feedback">
											{{ getFieldError('toCountry') }}
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select class="form-select h-50px fs-7" formControlName="toPort" id="to_port"
											[class.is-invalid]="isFieldInvalid('toPort')">
											<option value="" selected>Select Port</option>
											<option *ngFor="let port of toPortList" [value]="port.label">{{ port.label }}</option>
										</select>
										<label for="to_port" class="fs-7 text-gray-600"><span class="required">To Port</span></label>
										<div *ngIf="isFieldInvalid('toPort')" class="invalid-feedback">
											{{ getFieldError('toPort') }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-floating">
						<input type="text" formControlName="paymentTerms" id="shipperPaymentTerms"
							class="form-control h-50px fs-7"
							[class.is-invalid]="isFieldInvalid('paymentTerms')"
							maxlength="20" placeholder=" Payment Terms">
						<label for="shipperPaymentTerms" class="fs-7 text-gray-600"><span class=""> Payment Terms</span></label>
						<div *ngIf="isFieldInvalid('paymentTerms')" class="invalid-feedback">
							{{ getFieldError('paymentTerms') }}
						</div>
					</div>
				</div>
			</div>
			<div class="fv-row row mb-15">
				<div class="col-md-12">
					<div class="fv-row row d-flex" *ngFor="let vehicle of vehicles; let vIndex = index; trackBy: trackByVehicleIndex">
						<div class="col-md-5 col-sm-12 d-flex flex-column">
							<div class="d-flex justify-content-between align-center mb-5">
								<h4 class="mb-0 d-flex align-items-center">Stock Information <span class="required"></span></h4>
								<div class="d-flex gap-2">
									<button *ngIf="!isVehicleFromProforma(vehicle)" type="button" class="btn btn-sm btn-dark" (click)="openCarListingModal(vIndex)">Choose From Stock</button>
									<button *ngIf="vehicles[vIndex].stockId" type="button" class="btn btn-sm btn-primary" (click)="editVehicle(vehicles[vIndex].stockId)">
										<i class="ki-duotone ki-pencil fs-6">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
										Edit Vehicle
									</button>
									<button type="button" class="btn btn-sm btn-dark" (click)="resetVehicle(vIndex)">Reset</button>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-12 mb-5">
									<div class="dropzone" id="kt_ecommerce_add_product_media">
										<div class="dz-message needsclick">
											<i class="ki-duotone ki-file-up text-primary fs-3x">
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
											<div class="ms-4">
												<h3 class="fs-5 fw-bold text-gray-900 mb-1">Drop files here or click to upload.</h3>
												<span class="fs-7 fw-semibold text-gray-500">Upload up to 10 files</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input
											type="text"
											id="stockMake_{{vIndex}}"
											class="form-control h-50px fs-7"
											[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'make')"
											placeholder="Enter Make"
											[(ngModel)]="vehicles[vIndex].stockMake"
											[ngModelOptions]="{standalone: true}"
											[disabled]="vehicles[vIndex].stockId"
											autocomplete="off" />
										<label for="stockMake_{{vIndex}}" class="fs-7 text-gray-600"><span class="required">Make</span></label>

										<!-- Validation Error Message -->
										<div *ngIf="isVehicleFieldInvalid(vIndex, 'make')" class="text-danger fs-7 mt-1">
											Vehicle {{ vIndex + 1 }} - Make is required
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input type="text" name="stockMakeNew_{{vIndex}}" id="stockMakeNew_{{vIndex}}" class="form-control h-50px fs-7" placeholder="Enter New Make" [(ngModel)]="vehicles[vIndex].stockMakeNew" [ngModelOptions]="{standalone: true}">
										<label for="stockMakeNew_{{vIndex}}" class="fs-7 text-gray-600">Enter New Make</label>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input
											type="text"
											id="stockModel_{{vIndex}}"
											class="form-control h-50px fs-7"
											[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'model')"
											placeholder="Enter Model"
											[(ngModel)]="vehicles[vIndex].stockModel"
											[ngModelOptions]="{standalone: true}"
											[disabled]="vehicles[vIndex].stockId"
											autocomplete="off" />
										<label for="stockModel_{{vIndex}}" class="fs-7 text-gray-600"><span class="required">Model</span></label>

										<!-- Model Validation Error Message -->
										<div *ngIf="isVehicleFieldInvalid(vIndex, 'model')" class="text-danger fs-7 mt-1">
											Vehicle {{ vIndex + 1 }} - Model is required
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input type="text" name="stockModelNew_{{vIndex}}" id="stockModelNew_{{vIndex}}" class="form-control h-50px fs-7" placeholder="Enter New Model" [(ngModel)]="vehicles[vIndex].stockModelNew" [ngModelOptions]="{standalone: true}">
										<label for="stockModelNew_{{vIndex}}" class="fs-7 text-gray-600">Enter New Model</label>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input type="text" name="stockModelCode_{{vIndex}}" id="stockModelCode_{{vIndex}}" class="form-control h-50px fs-7" placeholder="Model Code" [(ngModel)]="vehicles[vIndex].stockModelCode" [ngModelOptions]="{standalone: true}" [disabled]="vehicles[vIndex].stockId">
										<label for="stockModelCode_{{vIndex}}" class="fs-7 text-gray-600">Model Code</label>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input
											type="text"
											name="stockChassisNo_{{vIndex}}"
											id="stockChassisNo_{{vIndex}}"
											class="form-control h-50px fs-7"
											[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'chassisNo')"
											placeholder="EXZ-000333333"
											[(ngModel)]="vehicles[vIndex].stockChassisNo"
											[ngModelOptions]="{standalone: true}"
											[disabled]="vehicles[vIndex].stockId">
										<label for="stockChassisNo_{{vIndex}}" class="fs-7 text-gray-600"><span class="required">Chassis No.</span></label>
										<div *ngIf="isVehicleFieldInvalid(vIndex, 'chassisNo')" class="invalid-feedback">
											Vehicle {{ vIndex + 1 }} - Chassis No. is required
										</div>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6">
									<div class="fv-row row">
										<div class="col-md-6 col-sm-12 mb-5">
											<div class="form-floating">
												<select
													class="form-select h-50px fs-7"
													name="stockMFYear_{{vIndex}}"
													id="stockMFYear_{{vIndex}}"
													[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'mfYear')"
													[(ngModel)]="vehicles[vIndex].stockMFYear"
													[ngModelOptions]="{standalone: true}"
													[disabled]="vehicles[vIndex].stockId">
													<option value="" selected>Select Year</option>
													<option *ngFor="let year of mfYearsList" [value]="year.value">{{ year.label }}</option>
												</select>
												<label for="stockMFYear_{{vIndex}}" class="fs-7 text-gray-600"><span class="required"> Manufacturing Year</span></label>
												<div *ngIf="isVehicleFieldInvalid(vIndex, 'mfYear')" class="invalid-feedback">
													Vehicle {{ vIndex + 1 }} - Manufacturing Year is required
												</div>
											</div>
										</div>
										<div class="col-md-6 col-sm-12 mb-5">
											<div class="form-floating">
												<select class="form-select h-50px fs-7" name="stockMFMonth_{{vIndex}}" id="stockMFMonth_{{vIndex}}" [(ngModel)]="vehicles[vIndex].stockMFMonth" [ngModelOptions]="{standalone: true}" [disabled]="vehicles[vIndex].stockId">
													<option value="" selected>Select Month</option>
													<option *ngFor="let month of mfMonthList" [value]="month.value">{{ month.label }}</option>
												</select>
												<label for="stockMFMonth_{{vIndex}}" class="fs-7 text-gray-600"> Manufacturing Month</label>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="fv-row row">
										<div class="col-md-6 col-sm-12 mb-5">
											<div class="form-floating">
												<select
													class="form-select h-50px fs-7"
													name="stockRegYear_{{vIndex}}"
													id="stockRegYear_{{vIndex}}"
													[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'regYear')"
													[(ngModel)]="vehicles[vIndex].stockRegYear"
													[ngModelOptions]="{standalone: true}"
													[disabled]="vehicles[vIndex].stockId">
													<option value="" selected>Select Year</option>
													<option *ngFor="let year of regYearsList" [value]="year.value">{{ year.label }}</option>
												</select>
												<label for="stockRegYear_{{vIndex}}" class="fs-7 text-gray-600"><span class="required"> Registration Year</span></label>
												<div *ngIf="isVehicleFieldInvalid(vIndex, 'regYear')" class="invalid-feedback">
													Vehicle {{ vIndex + 1 }} - Registration Year is required
												</div>
											</div>
										</div>
										<div class="col-md-6 col-sm-12 mb-5">
											<div class="form-floating">
												<select class="form-select h-50px fs-7" name="stockRegMonth_{{vIndex}}" id="stockRegMonth_{{vIndex}}" [(ngModel)]="vehicles[vIndex].stockRegMonth" [ngModelOptions]="{standalone: true}" [disabled]="vehicles[vIndex].stockId">
													<option value="" selected>Select Month</option>
													<option *ngFor="let month of regMonthList" [value]="month.value">{{ month.label }}</option>
												</select>
												<label for="stockRegMonth_{{vIndex}}" class="fs-7 text-gray-600"> Registration Month</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select
											class="form-select h-50px fs-7"
											name="stockFuel_{{vIndex}}"
											id="stockFuel_{{vIndex}}"
											[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'fuel')"
											[(ngModel)]="vehicles[vIndex].stockFuel"
											[ngModelOptions]="{standalone: true}"
											[disabled]="vehicles[vIndex].stockId">
											<option value="" selected>Select Fuel</option>
											<option *ngFor="let fuel of fueltList" [value]="fuel.slug">{{ fuel.name }}</option>
										</select>
										<label for="stockFuel_{{vIndex}}" class="fs-7 text-gray-600"><span class="required">Fuel</span></label>
										<div *ngIf="isVehicleFieldInvalid(vIndex, 'fuel')" class="invalid-feedback">
											Vehicle {{ vIndex + 1 }} - Fuel is required
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input type="text" name="stockFuelNew_{{vIndex}}" id="stockFuelNew_{{vIndex}}" class="form-control h-50px fs-7" placeholder="Enter New Fuel" [(ngModel)]="vehicles[vIndex].stockFuelNew" [ngModelOptions]="{standalone: true}">
										<label for="stockFuelNew_{{vIndex}}" class="fs-7 text-gray-600">Enter New Fuel</label>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input
											type="text"
											name="stockExteriorColor_{{vIndex}}"
											id="stockExteriorColor_{{vIndex}}"
											class="form-control h-50px fs-7"
											[class.is-invalid]="isVehicleFieldInvalid(vIndex, 'exteriorColor')"
											placeholder="Enter Color"
											[(ngModel)]="vehicles[vIndex].stockExteriorColor"
											[ngModelOptions]="{standalone: true}"
											[disabled]="vehicles[vIndex].stockId">
										<label for="stockExteriorColor_{{vIndex}}" class="fs-7 text-gray-600"><span class="required">Exterior Color</span></label>
										<div *ngIf="isVehicleFieldInvalid(vIndex, 'exteriorColor')" class="invalid-feedback">
											Vehicle {{ vIndex + 1 }} - Exterior Color is required
										</div>
									</div>
								</div>
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<input type="text" name="stockExteriorColorNew_{{vIndex}}" id="stockExteriorColorNew_{{vIndex}}" class="form-control h-50px fs-7" placeholder="Enter New Color" [(ngModel)]="vehicles[vIndex].stockExteriorColorNew" [ngModelOptions]="{standalone: true}">
										<label for="stockExteriorColorNew_{{vIndex}}" class="fs-7 text-gray-600">Enter New Color</label>
									</div>
								</div>
							</div>
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<div class="form-floating">
										<select class="form-select h-50px fs-7" name="stockSteering_{{vIndex}}" id="stockSteering_{{vIndex}}" [(ngModel)]="vehicles[vIndex].stockSteering" [ngModelOptions]="{standalone: true}" [disabled]="vehicles[vIndex].stockId">
											<option value="" selected>Select</option>
											<option value="right">Right Hand</option>
											<option value="left">Left Hand</option>
										</select>
										<label for="stockSteering_{{vIndex}}" class="fs-7 text-gray-600">Steering</label>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-7 col-sm-12 d-flex flex-column">
							<div class="fv-row row">
								<div class="col-md-6 col-sm-12 mb-5">
									<h4 class="mb-0 d-flex align-items-center">Specific Information <span class="required"></span></h4>
								</div>
								<div class="col-md-6 col-sm-12 mb-5 d-flex justify-content-end">
									<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
										<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" id="selectAllProforma_{{vIndex}}" name="selectAllProforma_{{vIndex}}" [(ngModel)]="vehicle.selectAll" (change)="toggleAllProformaFields(vIndex)" [ngModelOptions]="{standalone: true}">
										<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Show All On Proforma</span>
									</label>
								</div>
							</div>
							<div class="fv-row row">
								<!-- Body Type -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockBodyType && vehicle.stockBodyType.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Body Type</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockBodyType" id="stockBodyType_{{vIndex}}" name="stockBodyType_{{vIndex}}" placeholder="Body Type" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockBodyType_{{vIndex}}" class="fs-7 text-gray-600">Body Type</label>
											</div>
										</div>
									</div>
								</div>
								<!-- HS Code -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockHSCode && vehicle.stockHSCode.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">HS Code</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockHSCode" id="stockHSCode_{{vIndex}}" name="stockHSCode_{{vIndex}}" placeholder="HS Code" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockHSCode_{{vIndex}}" class="fs-7 text-gray-600">HS Code</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Transmission -->
								<div class="col-md-12 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="(vehicle.stockTransmission && vehicle.stockTransmission.trim() !== '') || (vehicle.stockTransmissionNew && vehicle.stockTransmissionNew.trim() !== '')" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Transmission</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="fv-row row">
												<div class="col-md-6 col-sm-12">
													<div class="form-floating">
														<select class="form-select h-50px fs-7" [(ngModel)]="vehicle.stockTransmission" id="stockTransmission_{{vIndex}}" name="stockTransmission_{{vIndex}}" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
															<option value="" selected>Select Transmission</option>
															<option value="manual">Manual</option>
															<option value="automatic">Automatic</option>
															<option value="cvt">CVT</option>
															<option value="semi-automatic">Semi-Automatic</option>
														</select>
														<label for="stockTransmission_{{vIndex}}">Transmission</label>
													</div>
												</div>
												<div class="col-md-6 col-sm-12">
													<div class="form-floating">
														<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockTransmissionNew" id="stockTransmissionNew_{{vIndex}}" name="stockTransmissionNew_{{vIndex}}" placeholder="Enter New Transmission" [ngModelOptions]="{standalone: true}">
														<label for="stockTransmissionNew_{{vIndex}}" class="fs-7 text-gray-600">Enter New Transmission</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- Mileage -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockMileage && vehicle.stockMileage.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Mileage (Km)</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockMileage" id="stockMileage_{{vIndex}}" name="stockMileage_{{vIndex}}" placeholder="Mileage (Km)" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockMileage_{{vIndex}}" class="fs-7 text-gray-600">Mileage (Km)</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Engine No -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockEngineNo && vehicle.stockEngineNo.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Engine No.</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockEngineNo" id="stockEngineNo_{{vIndex}}" name="stockEngineNo_{{vIndex}}" placeholder="Engine No." [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockEngineNo_{{vIndex}}" class="fs-7 text-gray-600">Engine No.</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Seat Capacity -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockSeatCapacity && vehicle.stockSeatCapacity.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Seat Capacity</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockSeatCapacity" id="stockSeatCapacity_{{vIndex}}" name="stockSeatCapacity_{{vIndex}}" placeholder="Seat Capacity" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockSeatCapacity_{{vIndex}}" class="fs-7 text-gray-600">Seat Capacity</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Auction Hall -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockAuctionHall && vehicle.stockAuctionHall.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Auction Hall</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockAuctionHall" id="stockAuctionHall_{{vIndex}}" name="stockAuctionHall_{{vIndex}}" placeholder="Auction Hall" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockAuctionHall_{{vIndex}}" class="fs-7 text-gray-600">Auction Hall</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Stock / Lot No -->
								<div class="col-md-6 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockLotNo && vehicle.stockLotNo.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Stock / Lot No.</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<input type="text" class="form-control h-50px fs-7" [(ngModel)]="vehicle.stockLotNo" id="stockLotNo_{{vIndex}}" name="stockLotNo_{{vIndex}}" placeholder="Stock / Lot No." [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId">
												<label for="stockLotNo_{{vIndex}}" class="fs-7 text-gray-600">Stock / Lot No.</label>
											</div>
										</div>
									</div>
								</div>
								<!-- Options -->
								<div class="col-md-12 col-sm-12">
									<div class="fv-row row">
										<div style="width:150px" class="col-sm-12 mb-5 d-flex align-items-center">
											<label class="form-check form-check-sm form-check-custom form-check-inline m-0">
												<input type="checkbox" class="form-check-input bg-gray-200 rounded-0" [checked]="vehicle.stockOptions && vehicle.stockOptions.trim() !== ''" readonly/>
												<span class="form-check-label fw-semibold ps-2 m-0 fs-7">Options</span>
											</label>
										</div>
										<div style="width:calc(100% - 150px)" class="col-sm-12 mb-5">
											<div class="form-floating">
												<textarea class="form-control h-100px fs-7" [(ngModel)]="vehicle.stockOptions" id="stockOptions_{{vIndex}}" name="stockOptions_{{vIndex}}" placeholder="Options" [ngModelOptions]="{standalone: true}" [disabled]="vehicle.stockId" style="min-height: 80px;"></textarea>
												<label for="stockOptions_{{vIndex}}" class="fs-7 text-gray-600">Options</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12 d-flex justify-content-end" *ngIf="vehicles.length > 1">
							<button type="button" class="btn btn-sm btn-danger" (click)="removeVehicle(vIndex)">Remove</button>
						</div>
					</div>
					<!-- <button type="button" class="btn btn-sm btn-primary" (click)="addVehicle()"><i class="ki-duotone ki-plus fs-2"></i> Add More Vehicles</button> -->
				</div>
			</div>
			<div class="fv-row row mb-15">
				<div class="col-md-12">
					<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden">
						<thead>
							<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
								<th style="width: 50px;" valign="middle">S.No.</th>
								<th>Item Description</th>
								<th style="width: 100px;">Quantity</th>
								<th style="width: 120px;">Currency</th>
								<th style="width: 260px;">&nbsp;</th>
								<th style="width: 220px;">Amount</th>
								<th style="width: 80px;">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of items; let i = index">
								<td class="text-center">{{ i + 1 }}</td>
								<td>
									<input type="text"
										[class]="'form-control form-control-sm' + (i === 0 && isDescriptionAutoGenerated ? ' bg-light' : '') + (isItemFieldInvalid(i, 'description') ? ' is-invalid' : '')"
										name="desc{{i}}"
										[(ngModel)]="item.description"
										[placeholder]="i === 0 && isDescriptionAutoGenerated ? 'Auto-generated from selected make and model' : 'Enter description'"
										[ngModelOptions]="{standalone: true}"
										[readonly]="i === 0 && isDescriptionAutoGenerated"/>
									<div *ngIf="isItemFieldInvalid(i, 'description')" class="text-danger fs-8 mt-1">
										Item {{ i + 1 }} - Description is required
									</div>
								</td>
								<td>
									<input type="number"
										class="form-control form-control-sm text-center"
										[class.is-invalid]="isItemFieldInvalid(i, 'quantity')"
										name="qty{{i}}"
										[(ngModel)]="item.quantity"
										(ngModelChange)="updateTotal()"
										min="1"
										placeholder="Enter quantity"
										[ngModelOptions]="{standalone: true}"/>
									<div *ngIf="isItemFieldInvalid(i, 'quantity')" class="text-danger fs-8 mt-1">
										Item {{ i + 1 }} - Quantity is required
									</div>
								</td>
								<td>
									<select class="form-select form-select-sm fs-7"
										[class.is-invalid]="isItemFieldInvalid(i, 'currency')"
										name="curr{{i}}"
										[(ngModel)]="item.currency"
										[ngModelOptions]="{standalone: true}">
										<option value="" disabled selected>Select Currency</option>
										<option *ngFor="let currency of currencyList" [value]="currency">{{ currency }}</option>
									</select>
									<div *ngIf="isItemFieldInvalid(i, 'currency')" class="text-danger fs-8 mt-1">
										Item {{ i + 1 }} - Currency is required
									</div>
								</td>
								<td></td>
								<td><input type="text" class="form-control form-control-sm text-end" name="amt{{i}}" [value]="formatNumberWithCommasNoDecimals(item.amount)" (input)="onAmountInput($event, item)" placeholder="Enter amount (optional)" /></td>
								<td class="text-center">
									<button type="button" class="btn btn-sm btn-danger" (click)="removeItem(i)" *ngIf="items.length > 1">
										<i class="ki-solid ki-trash fs-5"></i>
									</button>
								</td>
							</tr>
							<tr>
								<td></td>
								<td class="text-end fw-bold">Total</td>
								<td class="text-center" valign="center">{{ getTotalQuantity() }} Unit</td>
								<td></td>
								<td></td>
								<td class="text-end" valign="center">{{ formattedTotal }}</td>
								<td></td>
							</tr>
							<!-- Dynamic Charges Rows -->
							<tr *ngFor="let charge of charges; let i = index">
								<td></td>
								<td></td>
								<td></td>
								<td>
									<select class="form-select form-select-sm"
											[(ngModel)]="charge.currency"
											[ngModelOptions]="{standalone: true}"
											(change)="onChargeCurrencyChange(i, charge.currency)">
										<option value="JPY">JPY</option>
										<option value="USD">USD</option>
									</select>
								</td>
								<td>
									<select class="form-select form-select-sm"
											[value]="charge.charge_type"
											(change)="onChargeTypeChange(i, $any($event.target).value)">
										<option value="" selected>Choose charge</option>
										<option  *ngFor="let item of chargesList" [value]="item.value" [selected]="item.value === charge.charge_type">
											{{ item.label }}
										</option>
									</select>
								</td>
								<td>
									<input type="number"
										   class="form-control form-control-sm text-end"
										   [(ngModel)]="charge.amount"
										   [ngModelOptions]="{standalone: true}"
										   placeholder="0"
										   min="0"
										   step="0.01" />
								</td>
								<td>
									<button type="button"
											class="btn btn-sm btn-light-danger"
											(click)="removeCharge(i)"
											*ngIf="charges.length > 1">
										<i class="ki-duotone ki-trash fs-5"></i>
									</button>
								</td>
							</tr>

							<!-- Add Charge Button Row -->
							<tr>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td colspan="2">
									<button type="button" class="btn btn-sm btn-light-primary w-100" (click)="addCharge()">
										<i class="ki-duotone ki-plus fs-5"></i> Add Charge
									</button>
								</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td class="text-end fw-bold" valign="middle">Discount (%)</td>
								<td></td>
								<td></td>
								<td><input type="number" class="form-control form-control-sm" [(ngModel)]="discountPercent" min="0" max="100" (input)="updateFinalTotal()" placeholder="Enter discount %" [ngModelOptions]="{standalone: true}"/></td>
								<td class="text-end" valign="middle">{{ formattedFinalTotal }}</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td class="text-end fw-bold" valign="middle">Ship Type</td>
								<td></td>
								<td></td>
								<td class="text-center" valign="center">
									<select class="form-select form-select-sm fs-7"
										formControlName="shipType"
										[class.is-invalid]="isFieldInvalid('shipType')">
										<option value="" disabled selected>Ship Type</option>
										<option value="Roro">Roro</option>
										<option value="Container">Container</option>
										<option value="Completely knocked Down">Completely knocked Down</option>
									</select>
									<div *ngIf="isFieldInvalid('shipType')" class="text-danger fs-8 mt-1">
										Ship Type is required
									</div>
								</td>
								<td class="text-end" valign="middle">{{ formattedFinalTotal }}</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td class="text-end fw-bold" valign="middle">G.Total:</td>
								<td></td>
								<td></td>
								<td class="text-center" valign="center">
									<select class="form-select form-select-sm fs-7"
										formControlName="totalType"
										[class.is-invalid]="isFieldInvalid('totalType')">
										<option value="" disabled selected>Select Item</option>
										<option value="C&amp;F">C&amp;F </option>
										<option value="CIF">CIF</option>
										<option value="FOB">FOB</option>
										<option value="CKD">CKD</option>
										<option value="Local">Local</option>
										<option value="Auction Deposit">Auction Deposit </option>
									</select>
									<div *ngIf="isFieldInvalid('totalType')" class="text-danger fs-8 mt-1">
										Total Type is required
									</div>
								</td>
								<td class="text-end" valign="middle">{{ formattedFinalTotal }}</td>
								<td></td>
							</tr>
							<tr>
								<td></td>
								<td class="text-end fw-bold" valign="middle">Agent Notes </td>
								<td></td>
								<td class="text-center" valign="center"></td>
								<td colspan="3" class="text-end" valign="middle">
									<textarea class="form-control form-control-lg"
										formControlName="agentNotes"
										placeholder="Enter agent notes"></textarea>
								</td>
							</tr>
						</tbody>
					</table>
					<!-- <div class="d-flex justify-content-end mt-3">
						<button type="button" class="btn btn-sm btn-primary" (click)="addItem()">
							<i class="ki-duotone ki-plus fs-2"></i> Add Item
						</button>
					</div> -->
				</div>
			</div>
		</div>
		<div class="card-footer d-flex justify-content-end py-6 px-9">
			<button type="button" class="btn btn-light me-3">Cancel</button>
			<button type="button" class="btn btn-light btn-active-light-primary me-2" (click)="proformaForm.reset(); initializeForm()">Reset</button>
			<button #submitBtn type="submit" class="btn btn-primary indicator"
				id="performa_add_submit"
				[disabled]="isLoading">
				<span class="indicator-label" *ngIf="!isLoading">Save Proforma</span>
				<span class="indicator-progress" *ngIf="isLoading">Please wait...
					<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
			</button>
		</div>
	</div>
</form>

<!-- Car Listing Modal -->
<app-car-listing (carsSelected)="onCarsSelected($event)"></app-car-listing>

<!-- Consignee List Modal -->
<app-consignee-list
  [companyId]="selectedCompanyForConsignee?._id || ''"
  [companyName]="selectedCompanyName"
  (consigneeSelected)="onConsigneeSelected($event)">
</app-consignee-list>
